const getEcommerceMetafield = () => {
  const marketMetafieldsEl = document.getElementById('react-market-metafields');
  const disableEcommerce = marketMetafieldsEl?.dataset.disableEcommerce || false;
  
  return disableEcommerce;
}

// contentfulLocale is the value returned from getContentfulLocale().
export const excludeFromLocale = (contentfulLocale: string, exclusionArray: string[] = []) => {
  if (exclusionArray.includes('EU non-eComm')) {
    const disableEcommerce = getEcommerceMetafield();
    if (disableEcommerce) {
      return true;
    }
  } else if (exclusionArray.includes('EU eComm-enabled')) {
    const disableEcommerce = getEcommerceMetafield();
    if (!disableEcommerce) {
      return true;
    }
  } else {
    // For the majority of cases, just simply exclude if the locale is in the exclusion array.
    return exclusionArray.includes(contentfulLocale);
  }

  return false;
}